import * as $ from "jquery";

const ZONEDEFAULT = "PT";
//const MDASH = "—";
//const NDASH = "–";
const RANGESEPARATOR = " – ";

const zoneadjust = {
    "PT": 0,
    "MT": 60,
    "CT": 120,
    "ET": 180,
};

const zonenamelong = {
    "PT": "Pacific Time",
    "MT": "Mountain Time",
    "CT": "Central Time",
    "ET": "Eastern Time",
};

const recognizedzones = {
    "America/Los_Angeles": "PT",
    "America/Denver": "MT",
    "America/Chicago": "CT",
    "America/New_York": "ET",
};

function getBrowserTimeZoneCode(): string {
    try {
        const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        //console.log("Browser timezone=" + browserTZ);
        if (browserTZ) {
            var mappedzone = recognizedzones[browserTZ];
            if (mappedzone) {
                return mappedzone;
            }
        }
    } catch (error) {
    }
    return ZONEDEFAULT;
}

export class AutoTimeZone {
    myzone: string;
    myadjust: number;
    myzonename: number;

    constructor() {
        this.myzone = getBrowserTimeZoneCode();
        this.myadjust = zoneadjust[this.myzone];
        this.myzonename = zonenamelong[this.myzone];
    }

    fixAutoTimes() {
        const self = this;
        // find auto time numbers
        const $autotimes = $(".autotz-time");
        $autotimes.each(function () {
            self.fixTime($(this));
        });
        const $autotimerange = $(".autotz-range");
        $autotimerange.each(function () {
            self.fixTimeRange($(this));
        });
        const $autotimezone = $(".autotz-timezone");
        $autotimezone.each(function () {
            self.fixTimezone($(this));
        });
        const $autotimezoneshort = $(".autotz-timezoneshort");
        $autotimezoneshort.each(function () {
            self.fixTimezoneShort($(this));
        });
    }

    // Show a time adjusted for timezone
    private fixTime($autotime: JQuery) {
        const startmin: number = parseInt(
            <string> ($autotime.data("startmin")),
        );
        const startminadjust = startmin + this.getTotalAdjustment($autotime);

        const text = this.formatMinutes(startminadjust);
        $autotime.text(text);
    }

    // Show a time range adjusted for timezone
    private fixTimeRange($autotime: JQuery) {
        const startmin: number = parseInt(
            <string> ($autotime.data("startmin")),
        );
        const endmin: number = parseInt(<string> ($autotime.data("endmin")));
        const adjustment = this.getTotalAdjustment($autotime);
        const startminadjust = startmin + adjustment;
        const endminadjust = endmin + adjustment;

        const text = this.formatMinutes(startminadjust) + RANGESEPARATOR +
            this.formatMinutes(endminadjust);
        $autotime.text(text);
    }

    // Show a shortened timezone
    private fixTimezoneShort($autotime: JQuery) {
        $autotime.text(this.myzone);
    }

    // Show a timezone
    private fixTimezone($autotime: JQuery) {
        $autotime.text(this.myzonename);
    }

    // Calculates how much we should adjust the time
    private getTotalAdjustment($autotime: JQuery): number {
        const timezone: string = <string> $autotime.data("timezone");
        if (timezone) {
            const tzadjust = zoneadjust[timezone];
            if (tzadjust) {
                return this.myadjust - tzadjust;
            }
        }

        return this.myadjust;
    }

    /* Don't show the minutes if ===0 */
    formatMinutes(totalminutes: number): string {
        const hour = Math.floor(totalminutes / 60);
        const minute = totalminutes - (hour * 60);
        const isPm = hour >= 12;
        const ampm = isPm ? "PM" : "AM";
        const hour12 = hour === 0 ? 12 : (hour > 12 ? hour - 12 : hour);

        if (minute === 0) {
            return hour12.toString() + ampm;
        } else {
            const smin = minute > 10 ? minute.toString() : "0" + minute;
            return hour12.toString() + ":" + smin + ampm;
        }
    }
}
